<!--告警-->
<template>
  <div class="section-main__warp history-alarm">
    <ioc-table
      ref="crud"
      v-model="queryForm"
      :data="tableData"
      :option="option"
      :page="page"
      @export-change="exportDocument"
      @search-change="handleSearchChange"
      @search-reset="handleSearchReset"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @refresh-change="refreshChange"
      @selection-change="handleSelectionChange"
    >
      <template slot="search_alarmTime">
        <div>
          <el-date-picker
            type="datetime"
            placeholder="请选择开始时间"
            v-model="searchParams.startTime"
            default-time="00:00:00"
            style="width: 182px"
          ></el-date-picker>
          <span style="padding: 0 5px">至</span>
          <el-date-picker
            type="datetime"
            placeholder="请选择结束时间"
            v-model="searchParams.endTime"
            default-time="23:59:59"
            style="width: 182px"
          ></el-date-picker>
        </div>
      </template>
      <template slot="menuLeft">
        <el-button
          v-auth="'/fireHistory:export'"
          type="primary"
          icon="el-icon-download"
          :loading="exportDisabled"
          @click="exportDocument"
          >{{ exportDisabled ? "正在导出" : "导出" }}</el-button
        >
        <el-button type="primary" :loading="mergeLoading" @click="onMergeList">{{
          alarmMergeFlag ? "取消一键合并" : "一键合并"
        }}</el-button>
      </template>

      <!-- 楼栋查询条件 2021。8。9日屏蔽该需求 -->
      <!-- <template slot="search_buildingCodeList">
        <div class="tag-container">
          <span v-if="alarmArea"
                class="el-icon-circle-close claer-area-btn"
                @click="clearArea"></span>
          <el-button type="text"
                     class="choice-btn"
                     @click="choiceClick">
            选择</el-button>
          <el-input v-model="formData.buildingNames"
                    :disabled="true"
                    :title="formData.buildingNames">
          </el-input>
        </div>
      </template> -->
      <!-- 暂不使用自定义插槽 -->
      <template slot="search_parentDeviceName">
        <!-- <el-cascader
          placeholder="请输入"
          v-model="parentDeviceName"
          :show-all-levels="false"
          clearable
          @change="cascaderChange"
          :options="restaurants"
          :props="cascaderProps2"
          filterable
        ></el-cascader> -->
        <el-select
          filterable
          clearable
          v-model="formData.parentDeviceName"
          placeholder="请选择主机名称"
        >
          <el-option
            v-for="(item, index) in restaurants"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
      <!-- <template slot="search_parentThirdAlarmDevId">
        <el-select v-model="formData.parentThirdAlarmDevId"
                   placeholder="请选择编号">
          <el-option v-for="item in restaurants"
                     :key="item.id"
                     :label="item.id"
                     :value="item.id">
          </el-option>
        </el-select>
      </template> -->
      <!-- <template slot="search_subSystem">
        <el-select v-model="formData.subSystem"
                   @change="changeSubSystem"
                   clearable
                   placeholder="请选择记录类型">
          <el-option v-for="(item,index) in subSystemOptions"
                     :key="index"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </template> -->
      <!-- <template slot="search_alarmType">
        <el-select
          v-model="formData.alarmType"
          :multiple="false"
          clearable
          placeholder="请选择设备告警类型"
        >
          <el-option
            v-for="(item, index) in alarmTypeOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template> -->

      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="handleView(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
      </template>
      <template slot="commonAlarmType" slot-scope="scope">
        <span
          :class="showColor(scope.row.commonAlarmType)"
          style="cursor: pointer"
          @click="handleView(scope.row, scope.index)"
        >
          {{ scope.row.commonAlarmType | dic("SENU097003004") }}</span
        >
      </template>
      <template slot="alarmType" slot-scope="scope">
        <span> {{ queryAlarmType(scope.row.alarmType) }}</span>
      </template>
      <template slot="subSystem" slot-scope="scope">
        <span> {{ scope.row.subSystem == "4" ? "消防主机告警" : "电气火灾告警" }}</span>
      </template>
      <template slot="alarmLevel" slot-scope="scope">
        <span
          :class="alarmColor(scope.row.alarmLevel)"
          style="cursor: pointer"
          @click="handleView(scope.row, scope.index)"
        >
          {{ scope.row.alarmLevel | dic("SENU017") }}</span
        >
      </template>
      <template slot="multiAlarmType" slot-scope="scope">
        <span v-if="scope.row.commonAlarmType == '4001'">{{
          scope.row.multiAlarmType | dic("SENU100")
        }}</span>
        <span v-else> {{ queryAlarmType(scope.row.alarmType) }}</span>
      </template>
      <template slot="deviceName" slot-scope="scope">
        <span> {{ scope.row.subSystem == "4" ? scope.row.deviceName : "" }}</span>
      </template>
    </ioc-table>
    <appPanel
      class="app-panel"
      :isExpand="detailVisible"
      @cancel="detailVisible = false"
      title="报警信息详情"
    >
      <!-- <el-dialog
      title="报警信息详情"
      v-dialogDrag
      :visible.sync="detailVisible"
      width="40%"
      class="detail-continer"
    > -->
      <el-scrollbar>
        <el-form stripe>
          <div class="detail">
            <h3 class="detailTitle">基本信息</h3>
            <el-row>
              <el-col :span="12">
                <el-form-item label="告警类型：" class="col">
                  <span :class="showColor(detailData.commonAlarmType)">{{
                    detailData.commonAlarmType | dic("SENU097003004")
                  }}</span>
                  <!-- <span :class="detailData.subSystem == '4' ? showColor( detailData.commonAlarmType) : showColor( detailData.alarmType)">{{detailData.subSystem == '4' ?detailData.commonAlarmTypeLabel : detailData.alarmTypeLabel}}</span> -->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="设备告警类型：" class="col">
                  {{ queryAlarmType(detailData.alarmType) }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="告警时间：" class="col">
                  {{ detailData.alarmTime | moment }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="告警级别：" class="col">
                  <span :class="alarmColor(detailData.alarmLevel)">
                    {{ detailData.alarmLevel | dic("SENU017") }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="告警描述："
                  class="col"
                  v-if="detailData.subSystem == '13'"
                >
                  {{ detailData.desc }}
                </el-form-item>
                <el-form-item label="告警描述：" class="col" v-else>
                  <span v-if="detailData.desc">{{ detailData.desc }}</span>
                  <span v-else>
                    <span v-if="detailData.buildingName && detailData.buildingName"
                      >在{{ detailData.buildingName }}位置,{{
                        detailData.subDeviceMark | dic("SENU094")
                      }}上报
                      <span
                        v-if="detailData.commonAlarmType"
                        :class="showColor(detailData.commonAlarmType)"
                        >{{ detailData.commonAlarmType | dic("SENU097003004") }}</span
                      >
                    </span>
                  </span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div class="process-detail">
            <h3 class="detailTitle">告警详情</h3>
            <el-row>
              <el-col :span="12">
                <el-form-item label="主机类型（厂商）：" class="col">
                  {{ detailData.deviceType | dic("SENU087") }}
                  <span
                    v-if="
                      detailData.deviceType ||
                      detailData.parentFactoryName ||
                      detailData.factoryName
                    "
                    >(</span
                  >
                  {{
                    detailData.subDeviceMark
                      ? detailData.parentFactoryName
                      : detailData.factoryName
                  }}
                  <span
                    v-if="
                      detailData.deviceType ||
                      detailData.parentFactoryName ||
                      detailData.factoryName
                    "
                    >)</span
                  >
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="主机名称（编号）：" class="col">
                  {{
                    detailData.subDeviceMark
                      ? detailData.parentDeviceName
                      : detailData.deviceName
                  }}
                  <span
                    v-if="
                      detailData.parentDeviceName ||
                      detailData.deviceName ||
                      detailData.parentThirdAlarmDevId
                    "
                    >(</span
                  >
                  {{ detailData.parentThirdAlarmDevId }}
                  <span
                    v-if="
                      detailData.parentDeviceName ||
                      detailData.deviceName ||
                      detailData.parentThirdAlarmDevId
                    "
                    >)</span
                  >
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="部件名称：" class="col">
                  {{ detailData.subDeviceMark ? detailData.deviceName : "" }}
                  <span
                    v-if="detailData.componentThirdAlarmDevId && detailData.deviceName"
                    >(</span
                  >
                  {{ detailData.componentThirdAlarmDevId }}
                  <span
                    v-if="detailData.componentThirdAlarmDevId && detailData.deviceName"
                    >)</span
                  >
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="部件地址：" class="col">
                  {{ detailData.mac }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="唯一标识号：" class="col">
                  {{ detailData.thirdAlarmDevId }}
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="回路：" class="col">
                  {{ detailData.loopThirdAlarmDevId }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分机号：" class="col">
                  {{ detailData.childThirdAlarmDevId }}
                </el-form-item>
              </el-col> -->
              <el-col :span="12">
                <el-form-item label="报警：" class="col">
                  <span v-if="detailData.commonAlarmType == '4001'">{{
                    detailData.multiAlarmType | dic("SENU100")
                  }}</span>
                  <span v-else> {{ queryAlarmType(detailData.alarmType) }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="报警所在位置：" class="col">
                  {{ detailData.buildingName }}
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 楼栋基本信息 -->
            <el-row>
              <el-col :span="24">
                <div @click="isExpand = !isExpand" class="col">
                  <span style="color: #2a65ff; cursor: pointer">楼栋基本信息</span>
                  <el-button
                    type="text"
                    style="
                      margin-right: 25px;
                      font-size: 16px;
                      margin-top: 7px;
                      color: #2a65ff;
                    "
                    :class="[
                      'iconfont-lunan icon-lunan-xiaosanjiaodown',
                      isExpand ? 'icon-transform' : '',
                    ]"
                  >
                  </el-button>
                </div>
              </el-col>
            </el-row>
            <el-collapse-transition>
              <el-row v-if="isExpand">
                <el-col :span="24">
                  <el-form-item label="楼栋管理员：">
                    {{ buildingPerson }}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="安全员：" class="col">
                    {{ securityPersonnel }}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="备用安全员：" class="col">
                    {{ alternatePersonnel }}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="单体内经常有人值班的房间的座机：" class="col">
                    {{ detailData.officePhone }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-transition>
          </div>

          <div class="process-detail">
            <h3 class="detailTitle">处理详情</h3>
            <el-row>
              <el-col :span="12">
                <el-form-item label="处理人员：" class="col">
                  {{ detailData.modifierName || detailData.modifier }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="处理时间：" class="col">
                  {{ detailData.modifyTime | moment }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="告警处置状态：" class="col">
                  {{ queryHandleStatus(detailData.alarmState) }}
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
              <el-form-item label="处理原因："
                            class="col">
                {{ queryHandleStatus(detailData.alarmState) }}
              </el-form-item>
            </el-col> -->

              <el-col :span="12">
                <el-form-item label="处理描述：" class="col">
                  {{ detailData.processDesc }}
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </el-scrollbar>

      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>

        <el-button
          @click="handelShowTaskDetail"
          type="primary"
          v-if="detailData.alarmState == '4' || detailData.alarmState == '10'"
          >查看任务详情</el-button
        >
      </span>
      <!-- </el-dialog> -->
    </appPanel>

    <!-- 任务详情 -->
    <iocDialog
      ref="taskDetail"
      title="任务详情"
      :showFooter="false"
      class="taskDetail-container"
      width="600px"
    >
      <ioc-detail :option="taskOption" v-model="currentTask"></ioc-detail>
      <div class="ioc-detail__box clearfix img-content mt10">
        <span class="ioc-detail__label ioc-detail__label--right">相关文件 : </span>
        <span class="ioc-detail__content fl">
          <app-file-list-show
            :fileInfoList="currentTask.fileInfoList"
            :taskAlarmInfo="currentAlarm"
            @enlargeImage="enlargeImage"
          ></app-file-list-show>
        </span>
      </div>
      <!-- <ioc-tabs :option="tapOption"
                @change="handleTabChange"></ioc-tabs> -->
      <ioc-tab-group :option="tapOption" @change="handleTabChange"></ioc-tab-group>
      <div
        v-if="currentTab.prop === 'tab1' || !currentTab.prop"
        style="height: 140px; overflow-y: auto"
      >
        <el-table
          ref="personList"
          :data="currentTask.subTaskInfoList"
          style="width: 100%"
        >
          <el-table-column prop="executor" label="执行人编号"> </el-table-column>
          <el-table-column prop="executorName" label="执行人员"> </el-table-column>
          <el-table-column prop="status" label="执行情况">
            <template slot-scope="scope">
              {{ scope.row.status | dic("SENU055") }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        v-else-if="currentTab.prop === 'tab2'"
        style="margin: 0 20px; overflow-y: auto"
      >
        <div>
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in currentTask.taskExecutionLogList"
              :key="index"
              placement="top"
              :timestamp="activity.operateTime | moment"
            >
              <p>执行人：{{ activity.operator }}</p>
              <p>执行动作：{{ formatter(execute, activity.action) }}</p>
              <p>催办执行人：{{ activity.executor }}</p>
              <p class="word-break-all">描述：{{ activity.desc }}</p>
              <el-row>
                <el-col :span="5"> 相关文件： </el-col>
                <el-col :span="18">
                  <app-file-list-show
                    :fileInfoList="activity.fileInfos"
                    @enlargeImage="enlargeImage"
                  ></app-file-list-show>
                </el-col>
              </el-row>
            </el-timeline-item>
          </el-timeline>
          <!-- 执行明细无数据时展示暂无数据 -->
          <div
            v-if="currentTask.taskExecutionLogList.length === 0"
            class="table-empty"
            style="text-align: center"
          >
            <img src="@/common/assets/images/empty.svg" />
            <p>暂无数据</p>
          </div>
        </div>
      </div>
      <div v-else-if="currentTab.prop === 'tab3'">
        <div class="ioc-detail">
          <div class="ioc-group">
            <div class="el-row ioc-group__item" span="24">
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-24">
                <div class="ioc-detail__box">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >告警名称:</span
                  >
                  <span class="ioc-detail__content"> {{ currentAlarm.alarmName }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
                <div class="ioc-detail__box">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >设备告警类型:</span
                  >
                  <span class="ioc-detail__content">{{
                    currentAlarm.alarmTypeLabel
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
                <div class="ioc-detail__box">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >告警级别:
                  </span>
                  <span class="ioc-detail__content">{{
                    currentAlarm.alarmLevel | dic("SENU017")
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
                <div class="ioc-detail__box">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >告警时间:
                  </span>
                  <span class="ioc-detail__content">{{
                    currentAlarm.alarmTime | moment
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
                <div class="ioc-detail__box">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >设备组名称:</span
                  >
                  <span class="ioc-detail__content">{{
                    currentAlarm.deviceWorkGroupName
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-content">
        <el-button type="primary" @click="confirmDetail" class="confirm">
          关闭
        </el-button>
      </div>
    </iocDialog>
  </div>
</template>
<script>
import { tableOption, taskOption, tapOption } from "../config/HistoryAlarmTable";
import { Dates, Dic } from "$utils";
import { api } from "../api";
import iocDialog from "@components/app-dialog";
import utils from "@src/common/utils";
import appFileListShow from "@src/components/business/app-file-list-show";
import appPanel from "@src/components/business/app-panel/index.vue";
export default {
  components: {
    iocDialog,
    appFileListShow,
    appPanel,
  },
  data() {
    return {
      parentDeviceName: [],
      cascaderProps2: {
        children: "children",
        label: "value",
        value: "id",
        expandTrigger: "hover",
      },
      mergeLoading: false,
      alarmMergeFlag: "",
      showBtnBlock: true,
      detailVisible: false,
      option: tableOption(),
      tapOption: tapOption(),
      taskOption: taskOption(),
      exportDisabled: false,
      tableData: [],
      detailData: {},
      queryForm: {
        date: [new Date(Date.now() - 89 * 24 * 3600 * 1000), new Date()],
      },
      page: {
        // 当前页
        currentPage: 1,
        // 查询记过总计
        total: 0,
        // 每页默认显示条数
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      searchParams: {
        alarmTypeList: "",
      },
      areaTree: {},
      formData: {
        subSystem: "",
        alarmType: "",
      },
      alarmArea: [],
      currentTask: {},
      currentAlarm: {},
      currentTab: {},
      restaurants: [],
      subSystemOptions: [
        {
          label: "消防主机告警",
          value: 4,
        },
        {
          label: "电气火灾告警",
          value: 13,
        },
      ],
      alarmTypeOptions: [],
      execute: Dic.find("SENU056"), // 执行动作
      isExpand: false,
      buildingPerson: "", //详情页的楼栋管理员
      securityPersonnel: "", //详情页的楼栋安全员
      alternatePersonnel: "", //详情页的楼栋备用安全员
      nameArr: {},
    };
  },
  created() {
    this.getDeviceList();
    // this.nameArr = {};
    // for (var i = 65; i < 91; i++) {
    //   this.nameArr[String.fromCharCode(i) + "区"] = [];
    // }
    // this.queryFireDevice();
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    currentTheme() {
      return this.$store.getters.currentTheme;
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    cascaderChange(value) {
      if (value.length) {
        this.formData.parentDeviceName = value[1];
      } else {
        this.formData.parentDeviceName = "";
      }
    },
    queryFireDevice() {
      this.$fetch(api.cms.queryFireDevice, {
        deviceMarkList: ["27", "28", "29"],
        pageNum: 1,
        pageSize: 10000,
        systemId: "200000024",
      }).then((response) => {
        if (response.success) {
          let newArr = [];
          let otherArr = [];
          response.returnObj.list.forEach((el, index) => {
            let nameId = el.thirdDeviceName.slice(0, 2);
            if (this.nameArr[nameId]) {
              this.nameArr[nameId].push({
                value: el.thirdDeviceName + " ( " + el.thirdDeviceId + " )",
                id: el.thirdDeviceId,
                deviceID: el.deviceID,
              });
            } else {
              otherArr.push({
                value: el.thirdDeviceName + " ( " + el.thirdDeviceId + " )",
                id: el.thirdDeviceId,
                deviceID: el.deviceID,
              });
            }
          });
          for (let key in this.nameArr) {
            if (this.nameArr[key].length > 0) {
              newArr.push({
                value: key,
                label: key,
                children: this.nameArr[key],
              });
            }
          }
          otherArr.push({
            value: "电气火灾",
            id: "电气火灾",
          });
          newArr.push({
            value: "其他",
            label: "其他",
            children: otherArr,
          });
          // console.log(newArr)
          this.restaurants = JSON.parse(JSON.stringify(newArr));
        } else {
          // this.$message.error(response.msgContent || "获取设备详情失败");
        }
      });
    },
    // 一键合并list
    onMergeList() {
      if (this.alarmMergeFlag == 1) {
        // 取消合并
        this.alarmMergeFlag = "";
      } else {
        // 合并
        this.alarmMergeFlag = 1;
      }
      this.getList();
    },
    changeSubSystem(val) {
      // 因设备告警类型查询条件是根据记录类型来展示的
      if (val == 4) {
        this.alarmTypeOptions = Dic.find("SENU004004");
      } else {
        this.alarmTypeOptions = Dic.find("SENU004013");
      }
    },
    confirmDetail() {
      this.$refs.taskDetail.showSingleDialog = false;
    },
    handleTabChange(column) {
      this.currentTab = column;
    },
    enlargeImage(item) {
      // this.resourceDailogShow = true
      // this.currentResource = item
    },
    handelShowTaskDetail() {
      if (!this.detailData.taskCode) {
        this.$message.warning("暂无详情，请稍后查看");
        return;
      }
      this.$fetch(api.historyAlarm.getTaskDetail, {
        taskCode: this.detailData.taskCode,
      }).then((response) => {
        if (response && response.success) {
          //成功才打开
          this.$refs.taskDetail.open();
          const params = {
            fileInfoList: response.returnObj.fileInfoList,
            subTaskInfoList: response.returnObj.subTaskInfoList,
            taskExecutionLogList: _.sortBy(response.returnObj.taskExecutionLogList, [
              "operateTime",
            ]),
          };
          this.currentTask = _.assign({}, params, response.returnObj.taskInfo);
          if (this.currentTask.status == 9) {
            // 任务已完成
            this.taskOption = taskOptionFinish(this);
            console.log(this.taskOption, "this.taskOption");
          } else if (this.currentTask.status != 9) {
            // 任务未完成
            this.taskOption = taskOption(this);
          }
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    //报警：一点报警、两点报警
    queryAlarm(value) {
      return Dic.findByValue("SENU100", Number(value));
    },
    queryAlarmType(value) {
      if (value && value.substr(0, 1) == "4") {
        //报警类型
        return Dic.findByValue("SENU004004", Number(value));
      } else {
        //报警类型
        return Dic.findByValue("SENU004013", Number(value));
      }
    },

    //处理状态
    queryHandleStatus(value) {
      return Dic.findByValue("SENU068", Number(value));
    },
    //保存楼栋选择
    // saveChecked (data) {
    //   this.searchParams.buildingCodeList = data.map((item) => {
    //     return item.buildingCode;
    //   });
    //   this.formData.buildingNames = data
    //     .map((item) => {
    //       return item.buildingName;
    //     })
    //     .join("/");
    // },
    // 清除楼栋选择
    // clearArea () {
    //   this.alarmArea = []
    //   this.formData.buildingNames = ""; // 输入框信息
    // },
    handleSelectionChange(selected) {
      this.multipleSelection = selected;
    },
    handleSearchChange(param) {
      console.log(param);
      console.log(this.formData);
      console.log(this.searchParams);
      // let tempObj = {};
      // tempObj.startTime = this.searchParams.startTime;
      // tempObj.endTime = this.searchParams.endTime;
      // this.searchParams = Object.assign(param, this.formData);
      this.searchParams = { ...this.searchParams, ...param, ...this.form };
      // this.searchParams.startTime = tempObj.startTime;
      // this.searchParams.endTime = tempObj.endTime;
      this.getList();
    },
    // 重置列表
    handleSearchReset() {
      this.formData = {
        subSystem: "",
        alarmType: "",
      };
      this.parentDeviceName = [];
      this.searchParams = {};
      this.alarmMergeFlag = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.refreshChange(this.page);
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.refreshChange(this.page);
    },
    refreshChange(page) {
      this.getList(page);
      console.log("refresh");
    },
    formatter(dataList, value) {
      let rtn = "";
      dataList.map((item) => {
        if (item.value == value) {
          rtn = item.label;
        }
      });
      return rtn;
    },

    //导出
    exportDocument() {
      const params = {
        alarmMergeFlag: this.alarmMergeFlag,
        subSystem: this.searchParams.subSystem ? this.searchParams.subSystem : "", //记录类型
        commonAlarmType: this.searchParams.commonAlarmType
          ? this.searchParams.commonAlarmType
          : "", //告警类型
        alarmType: this.searchParams.alarmType ? this.searchParams.alarmType : "", //设备告警类型
        alarmState: this.searchParams.alarmState ? this.searchParams.alarmState : "", //告警处置状态
        thirdAlarmDevId: this.searchParams.parentDeviceName
          ? this.searchParams.parentDeviceName
          : "", // 主机名称
        deviceName: this.searchParams.deviceName ? this.searchParams.deviceName : "", // 部件名称
        componentThirdAlarmDevId: this.searchParams.thirdAlarmDevId
          ? this.searchParams.thirdAlarmDevId
          : "", // 部件编号
        alarmTitle: this.searchParams.alarmTitle ? this.searchParams.alarmTitle : "",
        alarmStartTime: this.searchParams.startTime
          ? Dates.format(this.searchParams.startTime)
          : "", //'开始时间',
        alarmEndTime: this.searchParams.endTime
          ? Dates.format(this.searchParams.endTime)
          : "", //结束时间',
      };
      // console.log(params);
      // 兼容IE
      this.exportDisabled = true;
      this.$fetchDownLoad(api.record.exportHistoryFireAlarm, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        if (response.data || response.success) {
          const content = response.data;
          const blob = new Blob([content], {
            type: "application/vnd.ms-excel",
          });
          //  console.log('date',window.DATE)
          const fileName =
            "消防报警记录信息" + Dates.format(Date.now(), "yyyyMMddHHmmssms") + ".xlsx";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
          this.exportDisabled = false;
        } else {
          this.$message.error("导出请求失败，请稍后重试");
        }
      });
    },
    // 选择楼栋
    // choiceClick () {
    //   this.$refs["regionTree"].openDialog();
    // },
    getList() {
      const _this = this;
      const params = {
        subSystem: this.searchParams.subSystem ? this.searchParams.subSystem : "", //记录类型
        commonAlarmType: this.searchParams.commonAlarmType
          ? this.searchParams.commonAlarmType
          : "", //告警类型
        alarmType: this.searchParams.alarmType ? this.searchParams.alarmType : "", //设备告警类型
        alarmState: this.searchParams.alarmState ? this.searchParams.alarmState : "", //告警处置状态
        thirdAlarmDevId: this.searchParams.parentDeviceName
          ? this.searchParams.parentDeviceName
          : "", // 主机名称
        deviceName: this.searchParams.deviceName ? this.searchParams.deviceName : "", // 部件名称
        componentThirdAlarmDevId: this.searchParams.componentThirdAlarmDevId
          ? this.searchParams.componentThirdAlarmDevId
          : "", // 部件编号
        alarmStartTime: this.searchParams.startTime
          ? Dates.format(this.searchParams.startTime)
          : "", //'开始时间',
        alarmEndTime: this.searchParams.endTime
          ? Dates.format(this.searchParams.endTime)
          : "", //结束时间',
        alarmTitle: this.searchParams.alarmTitle ? this.searchParams.alarmTitle : "",
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        alarmMergeFlag: this.alarmMergeFlag,
      };
      // console.log('parms00000', this.searchParams);
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.record.queryHistoryFireAlarm, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);

        _this.tableData = Object.freeze(
          response.returnObj ? response.returnObj.list : []
        );
        _this.page.total = Object.freeze(
          response.returnObj ? response.returnObj.total : []
        );
      });
    },
    getDeviceList() {
      this.$fetch(api.cms.queryFireDevice, {
        deviceMarkList: ["27", "28", "29"],
        pageNum: 1,
        pageSize: 10000,
        systemId: "200000024",
      }).then((response) => {
        if (response.success) {
          this.restaurants = response.returnObj.list.map((el) => {
            return {
              value: el.thirdDeviceId,
              label: el.thirdDeviceName, // + " ( " + el.thirdDeviceId + " )"
            };
          });
          // 主机名称
          this.option.column[7].dicData = [
            {
              value: "",
              label: "全部",
            },
            {
              value: "-1",
              label: "电气火灾",
            },
          ].concat(
            response.returnObj.list.map((el) => {
              return {
                value: el.thirdDeviceId,
                label: el.thirdDeviceName + " ( " + el.thirdDeviceId + " )",
              };
            })
          );
          // 主机编号
          // this.option.column[6].dicData = response.returnObj.list.map(el => {
          //   return {
          //     value: el.thirdDeviceId,
          //     label: el.thirdDeviceId,
          //   }
          // })
        }
      });
    },
    handleView(row, index) {
      this.buildingPerson = "";
      this.securityPersonnel = "";
      this.alternatePersonnel = "";
      let params = {
        alarmId: row.alarmId,
      };
      this.$fetch(api.alarm.queryAlarmDetail, params).then((response) => {
        if (response.success) {
          this.detailVisible = true;
          this.detailData = response.returnObj;
          this.currentAlarm = response.returnObj;
          this.alarmLevel = this.detailData.alarmLevel;

          // 两点报警列表
          // this.relationAlarmInfoList = response.returnObj.relationAlarmInfoList
          // thirdAlarmDevId主机编号-分机编号-回路-部件编号（部件地址）

          if (
            this.detailData.buildingPersonnel &&
            this.detailData.buildingPersonnel.personnelName
          ) {
            this.buildingPerson =
              this.detailData.buildingPersonnel.personnelName +
              "(" +
              this.detailData.buildingPersonnel.personnelPhone +
              ")";
          }
          if (
            this.detailData.securityPersonnelList &&
            this.detailData.securityPersonnelList.length
          ) {
            this.detailData.securityPersonnelList.forEach((item, index) => {
              this.securityPersonnel +=
                item.personnelName + "(" + item.personnelPhone + ")、";
            });
            this.securityPersonnel = this.securityPersonnel.substring(
              0,
              this.securityPersonnel.lastIndexOf("、")
            );
          }
          if (
            this.detailData.alternatePersonnelList &&
            this.detailData.alternatePersonnelList.length
          ) {
            this.detailData.alternatePersonnelList.forEach((item, index) => {
              this.alternatePersonnel +=
                item.personnelName + "(" + item.personnelPhone + ")、";
            });
            this.alternatePersonnel = this.alternatePersonnel.substring(
              0,
              this.alternatePersonnel.lastIndexOf("、")
            );
          }
        } else {
          this.$message.error(response.msgContent || "获取消防告警详情失败");
        }
      });
    },
    closeDialog() {
      this.$refs.alarmDetail.close();
    },
    showColor(val) {
      if (val == "4001") {
        return "colorRed";
      } else if (val == "4002") {
        return "colorYellow";
      } else if (val == "4005" || val == "4008" || val == "4009" || val == "40099") {
        return "colorBlue";
      } else if (val == "130103") {
        return "colorYellow";
      } else if (val == "130101") {
        return "colorRed";
      } else {
        return "";
      }
    },
    alarmColor(level) {
      level = parseInt(level);
      let className = "";
      if (level === 1) {
        className = "instancy";
      }
      if (level === 2) {
        className = "severity";
      }
      if (level === 3) {
        className = "general";
      }
      if (level === 4) {
        className = "common";
      }
      return className;
    },
    getBuildingTree() {
      this.$fetch(api.cms.queryBuildingTree).then((response) => {
        if (response && response.success) {
          this.areaTree = response.returnObj;
          // this.filterOption = alarmFilterOption(this.areaTree)
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
@import "@src/modules/historyAlarm/style/history.scss";
// .el-cascader-panel {
//   @include set_theme_color(background-color, input-disabled-bg-color);
//   @include set_theme_color(border-color, active-border-color);
//   border: 1px solid;
//   border-radius: 3px;
// }
.history-alarm {
  width: 100%;
  display: flex;
  flex-direction: column;

  .el-table .cell.el-tooltip {
    white-space: break-spaces;
  }
  .exportbtn {
    width: 60px;
    display: inline;
  }
  .colorRed {
    color: red !important;
  }
  .colorYellow {
    color: rgb(255, 191, 1) !important;
  }
  .colorBlue {
    color: #409eff !important;
  }

  .icon-transform {
    transform: rotate(180deg);
  }
  .instancy {
    color: #ff4547;
  }

  .severity {
    color: #ff466e;
  }

  .general {
    color: #ffbf00;
  }
  .common {
    color: #2a65ff;
  }
  .lookPhoto {
    // margin: 0 auto;
    position: absolute;
    left: calc(50% - 150px);
  }
  .form {
    margin-left: 15px;
  }
  .alarm-name {
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 155px;
    white-space: nowrap;
    vertical-align: middle;
  }
  .detail {
    @include set_theme_color(background-color, blur-color);
    // background: #00407b;

    padding: 10px;
  }
  .process-detail {
    @include set_theme_color(background-color, blur-color);

    margin-top: 10px;
    padding: 10px;
  }
  .col {
    margin-top: -20px;
  }
  .detailTitle {
    height: 30px;
    line-height: 30px;
    margin-bottom: 20px;
    font-size: 15px;
    font-weight: bold;
    // vertical-align: center;
  }
  .footer-content {
    margin-top: 10px;
    text-align: right;
  }
  .el-dialog__footer {
    margin-top: 10px;
    text-align: center;
  }
  .ioc-history__list {
    flex: 1;
  }
  .img-content {
    .ioc-detail__content {
      width: 80%;
    }
    // padding-left: 20px;
  }
  .open-devices-button {
    color: #0086ff;
    font-weight: bolder;
    cursor: pointer;
    position: relative;
    top: -28px;
    left: 73%;
  }

  .tag-container {
    height: 28px;
    position: relative;

    input {
      padding-right: 60px;
      padding-left: 8px;
    }
  }
  .choice-btn {
    position: absolute;
    // color: #0086ff;
    top: 0;
    right: 5px;
    z-index: 3;
  }
  .claer-area-btn {
    position: absolute;
    top: 8px;
    color: #ccc;
    right: 40px;
    z-index: 3;
    cursor: pointer;
  }
  .handle-desc {
    display: inline-block;
    word-break: break-all;
  }
  .export-tips {
    margin-left: 5px;
    color: red;
    vertical-align: middle;
  }
  .taskDetail-container {
    // margin-left: 30%;
    .el-dialog {
      margin-top: 15vh !important;
    }
    z-index: 2026 !important;
    .ioc-detail__box {
      margin-top: 10px;
    }
    .ioc-detail {
      .ioc-group {
        @include set_theme_color(background-color, blur-color);
        opacity: 0.8;
        padding: 10px;
      }
    }
  }
}

.detail-continer {
  z-index: 2000 !important;
  .ioc-detail {
    .ioc-group {
      @include set_theme_color(background-color, blur-color);
      opacity: 0.8;
      padding: 10px;
      .ioc-group__title {
        margin-bottom: 5px;
      }
    }
  }
}
.v-modal {
  z-index: 1998 !important;
}
</style>
